/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
//Standard libraries
import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

//UI
import { StyledTypography, StyledBreadcrumbs } from "../../elements";
import { useTheme } from '@material-ui/core/styles';
import { useMediaQuery } from '@material-ui/core'
import { componenteSelector } from "../../../redux/selectors/componente";


interface BreadcrumbWidgetProps {
  cid: string;
  breadcrumbs: Array<any>;
}

/**
 * Breadcrumb widget component
 * @summary displays breadcrumb trail
 * `@prop {any} props` have following properties:
 * `@property {string} cid(required)` Unique identifier for layouts.
 * `@property {array} breadcrums(required)` It is an array and each element contains info such as a breadcrumb and link etc.
 */
export const BreadcrumbWidget: React.FC<BreadcrumbWidgetProps> = (
  props: any
) => {

  const componenteActual: any = useSelector(componenteSelector);

  const theme = useTheme();
  const xsWidth = useMediaQuery(theme.breakpoints.down('xs'));

  let productInfo = false

  if(componenteActual && componenteActual === 'product-information' && xsWidth){
    productInfo = true
  }

  const { breadcrumbs, cid } = props;
  return breadcrumbs && breadcrumbs.length ? (
      <StyledTypography variant="caption" component="div" style={{width: productInfo ? '105%': '',  marginRight: 0, marginLeft: productInfo ? -10 : ''}}>
        <StyledBreadcrumbs style={{width: '100%'}}>
            <Link
              color="inherit"
              to={"/"}
              key={"inicio"}
              id={`breadcrumb_a_1_inicio`}>
              Inicio
            </Link>
          {breadcrumbs.map((breadcrumb: any, index: number) =>
            index < breadcrumbs.length - 1 &&
            breadcrumb.seo &&
            breadcrumb.seo.href ? (
              <Link
                color="inherit"
                to={breadcrumb.seo.href}
                key={breadcrumb.value}
                id={`breadcrumb_a_1_${cid}_${index}`}>
                {breadcrumb.label}
              </Link>
            ) : (
              <span key={`${breadcrumb.value}_${index}`}>{breadcrumb.label}</span>
            )
          )}
        </StyledBreadcrumbs>
      </StyledTypography>
  ) : null;
};
